/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  if (window.isB2B === true) {
    console.log("[DISCOUNT] B2B mode detected");

    // Sepeti kontrol et, eğer indirim varsa temizle
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        // Sepette aktif bir indirim uygulaması var mı?
        const hasDiscount = cart.cart_level_discount_applications.length > 0 || 
                            cart.items.some(item => item.line_level_discount_allocations.length > 0);

        if (hasDiscount) {
          console.log("[DISCOUNT] Active discount found for B2B user. Clearing now...");
          
          // İndirimi sunucu tarafında sil
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ discount: "" }) // Kuponu temizle
          });
        }
      })
      .then(response => {
        if (response) {
          console.log("[DISCOUNT] Discount cleared. Reloading page to fix prices...");
          window.location.reload(); // Fiyatların orijinal haline dönmesi için şart
        }
      })
      .catch(err => console.error("[DISCOUNT] B2B clear error:", err));
  } else {
    console.log("[DISCOUNT] B2B mode not detected");
  
  // Discount Code Functionality - Advanced AJAX Version
  console.log("[DISCOUNT] Advanced script loading...");

  class DiscountCode {
    constructor(container) {
      this.container = container;
      this.input = container.querySelector('[id^="discount-code-input"]');
      this.button = container.querySelector('[id^="apply-discount-button"]');
      this.message = container.querySelector('[id^="discount-message"]');
      this.isDrawer =
        container.closest(".cart__drawer-form") !== null ||
        container.closest("cart-drawer") !== null ||
        container.closest(".drawer") !== null;

      console.log("[DISCOUNT] Script loaded for container:", container);
      console.log("[DISCOUNT] Is drawer:", this.isDrawer);
      this.init();
    }

    init() {
      if (this.button && this.input) {
        console.log("[DISCOUNT] Button and input found");
        this.button.addEventListener("click", this.applyDiscount.bind(this));

        // Allow applying discount with Enter key
        this.input.addEventListener("keypress", (e) => {
          if (e.key === "Enter") {
            this.applyDiscount();
          }
        });
      } else {
        console.warn("[DISCOUNT] Button or input not found");
      }
    }

    formatMoney(cents) {
      // Format money according to Turkish format
      const amount = (cents / 100).toFixed(2);
      const parts = amount.split(".");
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return integerPart + "," + parts[1] + " TL";
    }

    updateCartUI(cart) {
      console.log("[DISCOUNT] Updating cart UI...", cart);

      // Update subtotal with discount info (without changing the main price)
      const subtotalElement =
        document.querySelector("[data-subtotal]") ||
        document.querySelector(".totals__subtotal-value") ||
        document.querySelector(".cart__price__subtotal");
      console.log("[DISCOUNT] Subtotal element found:", subtotalElement);

      // Update discounts section - try multiple selectors for drawer vs cart page
      const discountsElement =
        document.querySelector("[data-discounts]") ||
        document.querySelector(".cart__total__discount") ||
        document.querySelector(".discounts") ||
        document.querySelector(".cart__discounts");

      console.log("[DISCOUNT] Discounts element found:", discountsElement);

      if (discountsElement) {
        if (
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0
        ) {
          const discountsHTML = cart.cart_level_discount_applications
            .map((discount) => {
              const discountAmount = this.formatMoney(
                discount.total_allocated_amount
              );

              // Different HTML structure for drawer vs cart page
              if (this.isDrawer) {
                return `
                <div class="cart__total cart__discount-item">
                  <div class="cart__discount-label">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tags" viewBox="0 0 25 26">
                      <g stroke="#000" stroke-width=".875">
                        <path d="M4.304.79h8.571l12 11.835M9.594 4.17H2.589c-.946 0-1.714.758-1.714 1.692v6.907c0 .449.18.88.502 1.196l10.47 10.329c.67.66 1.755.66 2.423 0 .173-.17.308-.376.394-.602l1.64-4.304 4.364-1.615a1.684 1.684 0 0 0 .61-2.779L10.805 4.666a1.725 1.725 0 0 0-1.211-.495Z"></path>
                        <path d="M6.018 8.82a.426.426 0 0 0-.429.423c0 .234.192.423.429.423.236 0 .428-.19.428-.423a.424.424 0 0 0-.426-.422h-.002"></path>
                      </g>
                    </svg>
                    <span>${discount.title}</span>
                  </div>
                  <span class="cart__discount-amount">-${discountAmount}</span>
                </div>
              `;
              } else {
                return `
                <li class="discounts__discount discounts__discount--end">
                  <svg aria-hidden="true" focusable="false" viewBox="0 0 12 12" class="icon icon-discount color-foreground-75">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="m7 1 3 3-6 6-3-3 6-6Z"></path>
                  </svg>
                  ${discount.title} (-${discountAmount})
                </li>
              `;
              }
            })
            .join("");
          discountsElement.innerHTML = discountsHTML;

          // Show the discount section
          discountsElement.classList.remove("hidden");
          if (discountsElement.parentElement) {
            discountsElement.parentElement.classList.remove("hidden");
          }
        } else {
          discountsElement.innerHTML = "";
          discountsElement.classList.add("hidden");
        }
      }

      // Add discount savings info above/below subtotal - more prominent for drawer
      if (
        cart.cart_level_discount_applications &&
        cart.cart_level_discount_applications.length > 0
      ) {
        const totalDiscountAmount =
          cart.cart_level_discount_applications.reduce((sum, discount) => {
            return sum + discount.total_allocated_amount;
          }, 0);

        const savingsText = `Indirimden kazancınız: ${this.formatMoney(
          totalDiscountAmount
        )}`;

        // Remove existing savings info
        const existingSavings = document.querySelectorAll(
          ".discount-savings-info"
        );
        existingSavings.forEach((el) => el.remove());

        // Add new savings info
        const savingsDiv = document.createElement("div");
        savingsDiv.className = this.isDrawer
          ? "discount-savings-info discount-savings-info--drawer"
          : "discount-savings-info discount-savings-info--page";

        savingsDiv.textContent = savingsText;

        // Insert savings info in appropriate location
        if (subtotalElement && subtotalElement.parentNode) {
          if (this.isDrawer) {
            // In drawer, add it prominently after the subtotal section
            const cartPriceHolder = subtotalElement.closest(
              ".cart__price__holder"
            );
            if (cartPriceHolder) {
              cartPriceHolder.appendChild(savingsDiv);
            } else {
              subtotalElement.parentNode.appendChild(savingsDiv);
            }
          } else {
            subtotalElement.parentNode.appendChild(savingsDiv);
          }
        }
      }

      // Update cart count if available
      const cartCountElements = document.querySelectorAll("[data-cart-count]");
      cartCountElements.forEach((el) => {
        el.textContent = cart.item_count;
      });

      // Clear input
      this.input.value = "";
    }

    applyDiscount() {
      const code = this.input.value.trim();
      console.log("[DISCOUNT] Apply clicked with code:", code);

      if (!code) {
        this.message.textContent = "Please enter a discount code.";
        this.message.className = "error";
        return;
      }

      this.button.disabled = true;
      this.button.textContent = "Applying...";
      this.message.textContent = "Applying discount...";
      this.message.className = "";

      // First check if discount is already applied
      fetch("/cart.js")
        .then((res) => res.json())
        .then((currentCart) => {
          console.log("[DISCOUNT] Current cart:", currentCart);

          // Check if this exact discount code is already applied
          const existingDiscounts =
            currentCart.cart_level_discount_applications || [];
          const isDuplicateDiscount = existingDiscounts.some((discount) => {
            // More precise matching - check if the discount title exactly matches or ends with the code
            const discountTitle = discount.title.toLowerCase();
            const inputCode = code.toLowerCase();
            return (
              discountTitle === inputCode ||
              discountTitle.endsWith(` ${inputCode}`) ||
              discountTitle.startsWith(`${inputCode} `)
            );
          });

          console.log("[DISCOUNT] Existing discounts:", existingDiscounts);
          console.log("[DISCOUNT] Is duplicate?", isDuplicateDiscount);

          if (isDuplicateDiscount) {
            this.message.textContent = `Discount "${code}" is already applied to your cart.`;
            this.message.className = "error";
            this.button.disabled = false;
            this.button.textContent = "Apply";
            return Promise.reject("duplicate"); // Stop the chain
          }

          // Proceed with applying the discount
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ discount: code }),
          });
        })
        .then((updateResponse) => {
          console.log(
            "[DISCOUNT] Update response status:",
            updateResponse.status
          );
          console.log("[DISCOUNT] Update response ok:", updateResponse.ok);
          return updateResponse.json().catch(() => ({})); // Handle empty response
        })
        .then((updateResult) => {
          console.log("[DISCOUNT] Update result:", updateResult);
          // Wait a bit then fetch cart
          return new Promise((resolve) => setTimeout(resolve, 300)).then(() =>
            fetch("/cart.js")
          );
        })
        .then((res) => res.json())
        .then((cart) => {
          console.log("[DISCOUNT] Full cart response:", cart);

          // Check multiple possible discount properties
          const cartLevelDiscounts =
            cart.cart_level_discount_applications || [];
          const totalDiscounts = cart.total_discount || 0;
          const discounts = cart.discounts || [];

          console.log("[DISCOUNT] Cart level discounts:", cartLevelDiscounts);
          console.log("[DISCOUNT] Total discount amount:", totalDiscounts);
          console.log("[DISCOUNT] Discounts array:", discounts);

          // Check if any discount is applied
          const hasCartLevelDiscount = cartLevelDiscounts.length > 0;
          const hasTotalDiscount = totalDiscounts > 0;
          const hasDiscountsArray = discounts.length > 0;

          const applied =
            hasCartLevelDiscount || hasTotalDiscount || hasDiscountsArray;

          if (applied) {
            this.message.textContent = `Discount "${code}" applied successfully!`;
            this.message.className = "success";

            if (this.isDrawer) {
              this.input.value = "";
              const cartDrawer = this.container.closest("cart-drawer");
              const cartItems = cartDrawer?.querySelector("cart-items");
              if (cartItems && typeof cartItems.getCart === "function") {
                cartItems.getCart();
              } else {
                this.updateCartUI(cart);
              }
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            } else {
              this.updateCartUI(cart);
              setTimeout(() => {
                location.reload();
              }, 1000);
            }
          } else {
            this.message.textContent = `Discount "${code}" is invalid or could not be applied.`;
            this.message.className = "error";
          }

          console.log("[DISCOUNT] Applied status:", applied);
        })
        .catch((err) => {
          if (err === "duplicate") {
            // Already handled above, don't show another error
            return;
          }
          this.message.textContent = "Failed to apply discount.";
          this.message.className = "error";
          console.error("[DISCOUNT] Error applying discount:", err);
        })
        .finally(() => {
          this.button.disabled = false;
          this.button.textContent = "Apply";
        });
    }
  }

  // Initialize discount code functionality when DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    console.log("[DISCOUNT] DOM Content Loaded, initializing...");

    // Initialize for cart page
    const cartPageDiscount = document.querySelector(".cart__discount");
    if (cartPageDiscount && !cartPageDiscount.closest("cart-drawer")) {
      console.log("[DISCOUNT] Cart page discount found");
      new DiscountCode(cartPageDiscount);
    }

    // Initialize for cart drawer
    const drawerDiscount = document.querySelector(
      "cart-drawer .cart__discount"
    );
    if (drawerDiscount) {
      console.log("[DISCOUNT] Drawer discount found");
      new DiscountCode(drawerDiscount);
    }
  });

  // Also initialize when cart drawer is opened (for dynamic content)
  document.addEventListener("cart:drawer:open", () => {
    console.log("[DISCOUNT] Cart drawer opened");
    setTimeout(() => {
      const drawerDiscount = document.querySelector(
        "cart-drawer .cart__discount"
      );
      if (drawerDiscount && !drawerDiscount.hasDiscountCode) {
        drawerDiscount.hasDiscountCode = true;
        console.log("[DISCOUNT] Initializing drawer discount");
        new DiscountCode(drawerDiscount);
      }
    }, 100);
  });

  // Initialize when cart drawer content changes
  if (typeof window.CartDrawer !== "undefined") {
    const originalOpen = window.CartDrawer.open;
    window.CartDrawer.open = function () {
      originalOpen.apply(this, arguments);
      setTimeout(() => {
        const drawerDiscount = document.querySelector(
          "cart-drawer .cart__discount"
        );
        if (drawerDiscount && !drawerDiscount.hasDiscountCode) {
          drawerDiscount.hasDiscountCode = true;
          new DiscountCode(drawerDiscount);
        }
      }, 200);
    };
  }

  // MutationObserver to watch for cart drawer content changes
  const observeCartDrawer = () => {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      console.log("[DISCOUNT] Setting up MutationObserver for cart drawer");

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            // Check if discount code elements were added
            const drawerDiscount = cartDrawer.querySelector(".cart__discount");
            if (drawerDiscount && !drawerDiscount.hasDiscountCode) {
              console.log(
                "[DISCOUNT] New discount code element found in drawer"
              );
              drawerDiscount.hasDiscountCode = true;
              new DiscountCode(drawerDiscount);
            }
          }
        });
      });

      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
      });
    }
  };

  // Initialize observer when DOM is ready
  setTimeout(() => {
    observeCartDrawer();
  }, 1000);

}

  // Infinite Scroll Functionality
  class InfiniteScroll {
    constructor() {
      // Support multiple container types: collection, search, and blog
      this.scrollContainer = document.getElementById('CollectionLoop') || 
                            document.getElementById('SearchLoop') || 
                            document.getElementById('BlogLoop') ||
                            document.querySelector('.blog-listing');
      
      this.paginationElement = document.querySelector('[data-infinite-scroll]');
      this.loadMoreButton = document.querySelector('.pagination-infinite__load-more');
      this.loader = document.querySelector('.grid__loader');
      
      this.isLoading = false;
      this.currentPage = 1;
      this.totalPages = 1;
      this.nextUrl = null;
      this.lastLoadedUrl = null;

      if (this.paginationElement && this.scrollContainer) {
        this.init();
      }
    }

    init() {
      // Get initial pagination data
      this.currentPage = parseInt(this.paginationElement.dataset.currentPage) || 1;
      this.totalPages = parseInt(this.paginationElement.dataset.totalPages) || 1;
      this.nextUrl = this.paginationElement.dataset.nextUrl || null;

      console.log('[INFINITE_SCROLL] Initialized:', {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        nextUrl: this.nextUrl,
        containerType: this.getContainerType()
      });

      // Bind events
      this.bindScrollEvent();
      this.bindLoadMoreButton();
    }

    getContainerType() {
      // First try to get from data attribute
      if (this.paginationElement && this.paginationElement.dataset.pageType) {
        return this.paginationElement.dataset.pageType;
      }
      
      // Fallback to element detection
      if (document.getElementById('CollectionLoop')) return 'collection';
      if (document.getElementById('SearchLoop')) return 'search';
      if (document.getElementById('BlogLoop')) return 'blog';
      if (document.querySelector('.blog-listing')) return 'blog';
      return 'unknown';
    }

    bindScrollEvent() {
      let ticking = false;
      
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      });
    }

    bindLoadMoreButton() {
      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.loadMore();
        });
      }
    }

    handleScroll() {
      if (this.isLoading || !this.nextUrl || this.currentPage >= this.totalPages) {
        console.log('[INFINITE_SCROLL] Scroll check failed:', {
          isLoading: this.isLoading,
          nextUrl: this.nextUrl,
          currentPage: this.currentPage,
          totalPages: this.totalPages
        });
        return;
      }

      // No additional URL checks in scroll event

      const scrollPosition = window.innerHeight + window.scrollY;
      const documentHeight = document.documentElement.offsetHeight;
      const threshold = 1600; // Load when 800px from bottom (much earlier trigger)

      if (scrollPosition >= documentHeight - threshold) {
        console.log('[INFINITE_SCROLL] Scroll threshold reached, calling loadMore');
        this.loadMore();
      }
    }

    async loadMore() {
      console.log('[INFINITE_SCROLL] loadMore called:', {
        isLoading: this.isLoading,
        nextUrl: this.nextUrl,
        currentPage: this.currentPage,
        totalPages: this.totalPages
      });
      
      if (this.isLoading) {
        console.log('[INFINITE_SCROLL] Already loading, skipping...');
        return;
      }
      
      if (!this.nextUrl) {
        console.log('[INFINITE_SCROLL] No next URL, skipping...');
        return;
      }
      
      if (this.currentPage >= this.totalPages) {
        console.log('[INFINITE_SCROLL] Already at last page, skipping...');
        return;
      }

      // Simple check: prevent loading same page number
      try {
        const url = new URL(this.nextUrl);
        const pageParam = url.searchParams.get('page');
        if (pageParam && parseInt(pageParam) <= this.currentPage) {
          console.log('[INFINITE_SCROLL] Page already loaded, skipping:', pageParam);
          return;
        }
      } catch (error) {
        console.log('[INFINITE_SCROLL] Could not parse URL for page check');
      }

      this.isLoading = true;
      this.showLoader();
      
      // Add timeout to prevent infinite loading
      const loadingTimeout = setTimeout(() => {
        if (this.isLoading) {
          console.log('[INFINITE_SCROLL] Loading timeout reached, resetting state');
          this.isLoading = false;
          this.hideLoader();
          this.showError();
        }
      }, 5000); // 5 second timeout (faster response)

      try {
        console.log('[INFINITE_SCROLL] Loading more content from:', this.nextUrl);

        const response = await fetch(this.nextUrl);
        const html = await response.text();
        
        // Parse the response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Extract new content based on container type
        let newContent;
        let newPagination;
        
        if (this.getContainerType() === 'blog') {
          // For blog pages, look for blog articles
          newContent = doc.querySelectorAll('#BlogLoop > *, .blog-listing > *');
          newPagination = doc.querySelector('[data-infinite-scroll]');
        } else {
          // For collection and search pages
          newContent = doc.querySelectorAll('#CollectionLoop > *, #SearchLoop > *');
          newPagination = doc.querySelector('[data-infinite-scroll]');
        }

        if (newContent.length > 0 && this.scrollContainer) {
          // Check for duplicates before adding
          let addedCount = 0;
          let skippedCount = 0;
          newContent.forEach((item, index) => {
            console.log(`[INFINITE_SCROLL] Checking item ${index + 1}/${newContent.length}`);
            if (!this.isItemAlreadyExists(item)) {
              this.scrollContainer.appendChild(item.cloneNode(true));
              addedCount++;
              console.log(`[INFINITE_SCROLL] Added item ${index + 1}`);
            } else {
              skippedCount++;
              console.log(`[INFINITE_SCROLL] Skipping duplicate item ${index + 1}`);
            }
          });
          
          console.log(`[INFINITE_SCROLL] Summary: ${addedCount} added, ${skippedCount} skipped out of ${newContent.length} total`);

          // If no new items were added, don't update pagination
          if (addedCount === 0) {
            console.log('[INFINITE_SCROLL] No new items added, skipping pagination update');
            this.hideLoader();
            this.isLoading = false;
            
            // Re-enable button after short delay
            setTimeout(() => {
              if (this.loadMoreButton) {
                this.loadMoreButton.disabled = false;
                this.loadMoreButton.classList.remove('loading');
                this.loadMoreButton.innerHTML = '<span>Daha Fazla Yükle</span>';
              }
            }, 1500); // Faster re-enable (1.5 seconds)
            
            return;
          }

          // Update pagination data
          if (newPagination) {
            const oldPage = this.currentPage;
            const oldNextUrl = this.nextUrl;
            
            this.currentPage = parseInt(newPagination.dataset.currentPage) || this.currentPage + 1;
            this.nextUrl = newPagination.dataset.nextUrl || null;
            
            console.log('[INFINITE_SCROLL] Pagination update:', {
              oldPage: oldPage,
              newPage: this.currentPage,
              oldNextUrl: oldNextUrl,
              newNextUrl: this.nextUrl,
              totalPages: this.totalPages
            });
            
            // Update pagination element
            this.paginationElement.dataset.currentPage = this.currentPage;
            if (this.nextUrl) {
              this.paginationElement.dataset.nextUrl = this.nextUrl;
            } else {
              this.paginationElement.removeAttribute('data-next-url');
            }
          } else {
            console.warn('[INFINITE_SCROLL] No new pagination element found in response');
          }

          // No need to track lastLoadedUrl for now
          
          // Clear loading timeout since we succeeded
          clearTimeout(loadingTimeout);

          console.log('[INFINITE_SCROLL] Content loaded successfully. Current page:', this.currentPage);

          // Hide load more button if no more pages
          if (this.currentPage >= this.totalPages || !this.nextUrl) {
            this.hideLoadMoreButton();
          }

          // Trigger custom event for other scripts
          window.dispatchEvent(new CustomEvent('infiniteScrollLoaded', {
            detail: {
              currentPage: this.currentPage,
              totalPages: this.totalPages,
              newContentCount: addedCount,
              containerType: this.getContainerType()
            }
          }));

        } else {
          console.warn('[INFINITE_SCROLL] No new content found');
          this.hideLoadMoreButton();
        }

      } catch (error) {
        console.error('[INFINITE_SCROLL] Error loading more content:', error);
        clearTimeout(loadingTimeout);
        this.showError();
      } finally {
        this.isLoading = false;
        this.hideLoader();
      }
    }

    isItemAlreadyExists(item) {
      if (!item) return true;
      
      // Get item identifier - normalize URL to remove query parameters
      let itemIdentifier;
      if (item.querySelector('a')) {
        const url = item.querySelector('a').href;
        itemIdentifier = url.split('?')[0]; // Remove query parameters
      } else {
        itemIdentifier = item.textContent.trim().substring(0, 50);
      }
      
      if (!itemIdentifier) return false;
      
      // Check if this item already exists in the container
      const existingItems = this.scrollContainer.querySelectorAll('*');
      for (let existingItem of existingItems) {
        let existingIdentifier;
        if (existingItem.querySelector('a')) {
          const url = existingItem.querySelector('a').href;
          existingIdentifier = url.split('?')[0]; // Remove query parameters
        } else {
          existingIdentifier = existingItem.textContent.trim().substring(0, 50);
        }
        
        if (existingIdentifier === itemIdentifier) {
          console.log('[INFINITE_SCROLL] Duplicate item found:', itemIdentifier);
          return true;
        }
      }
      
      return false;
    }

    showLoader() {
      if (this.loader) {
        this.loader.style.display = 'block';
        this.loader.classList.add('is-loading');
      }
      
      if (this.loadMoreButton) {
        this.loadMoreButton.disabled = true;
        this.loadMoreButton.classList.add('loading');
        this.loadMoreButton.innerHTML = '<span>Yükleniyor...</span>';
      }
    }

    hideLoader() {
      if (this.loader) {
        this.loader.style.display = 'none';
        this.loader.classList.remove('is-loading');
      }
      
      if (this.loadMoreButton && this.nextUrl && this.currentPage < this.totalPages) {
        this.loadMoreButton.disabled = false;
        this.loadMoreButton.classList.remove('loading');
        this.loadMoreButton.innerHTML = '<span>Daha Fazla Yükle</span>';
      }
    }

    hideLoadMoreButton() {
      if (this.loadMoreButton) {
        this.loadMoreButton.style.display = 'none';
      }
    }

    showError() {
      if (this.loadMoreButton) {
        this.loadMoreButton.disabled = false;
        this.loadMoreButton.classList.remove('loading');
        this.loadMoreButton.innerHTML = '<span>Hata! Tekrar Dene</span>';
      }
    }
  }

  // Initialize Infinite Scroll when DOM is ready
  let infiniteScrollInstance = null;
  
  const initInfiniteScroll = () => {
    if (!infiniteScrollInstance) {
      infiniteScrollInstance = new InfiniteScroll();
    }
  };
  
  // Reset instance when page changes (for SPA-like behavior)
  const resetInfiniteScroll = () => {
    if (infiniteScrollInstance) {
      infiniteScrollInstance = null;
    }
  };
  
  // Listen for page changes
  window.addEventListener('popstate', resetInfiniteScroll);
  
  // Reset on navigation (for Shopify's page transitions)
  document.addEventListener('shopify:section:load', resetInfiniteScroll);
  document.addEventListener('shopify:section:unload', resetInfiniteScroll);
  
  document.addEventListener('DOMContentLoaded', initInfiniteScroll);

  // Filtreleme yapıldığında (URL değiştiğinde veya içerik güncellendiğinde) script'i tazele
  const reinitInfiniteScroll = () => {
    console.log('[INFINITE_SCROLL] Re-initializing after filter or content change...');

    infiniteScrollInstance = null; 
    initInfiniteScroll();
  };


  document.addEventListener('shopify:section:load', reinitInfiniteScroll);

  window.addEventListener('popstate', reinitInfiniteScroll);

  const targetNode = document.querySelector('body');
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      // Eğer filtreleme sonucunda ürün konteynırı veya pagination değişmişse
      if (mutation.removedNodes.length > 0) {
        const isPaginationRemoved = Array.from(mutation.removedNodes)
          .some(node => node.nodeType === 1 && (node.hasAttribute('data-infinite-scroll') || node.querySelector('[data-infinite-scroll]')));
        
        if (isPaginationRemoved) {
          // Pagination elementinin silindiğini algıladık, yeni geleni bekleyip re-init yapalım
          setTimeout(reinitInfiniteScroll, 500); 
          break;
        }
      }
    }
  });

  observer.observe(targetNode, config);

  // Also initialize if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }

  // Gift Wrap Functionality
  console.log("[GIFT_WRAP] Script loading...");

  class GiftWrap {
    constructor() {
      this.checkbox = document.querySelector('[data-gift-wrap-checkbox]');
      this.container = document.querySelector('[data-gift-wrap-container]');
      this.loader = document.querySelector('[data-gift-wrap-loader]');
      this.variantId = this.checkbox ? this.checkbox.dataset.giftWrapVariantId : null;
      this.isProcessing = false;

      console.log("[GIFT_WRAP] Initialized:", {
        checkbox: !!this.checkbox,
        variantId: this.variantId
      });

      if (this.checkbox && this.variantId) {
        this.init();
      }
    }

    init() {
      // Check if gift wrap is already in cart on load
      this.checkGiftWrapInCart();

      // Remove any existing event listener (prevent duplicates)
      if (this.boundChangeHandler) {
        this.checkbox.removeEventListener('change', this.boundChangeHandler);
      }

      // Bind checkbox change event
      this.boundChangeHandler = this.handleCheckboxChange.bind(this);
      this.checkbox.addEventListener('change', this.boundChangeHandler);

      console.log("[GIFT_WRAP] Event listener attached to checkbox");
    }

    async checkGiftWrapInCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        const hasGiftWrap = cart.items.some(item => 
          item.variant_id.toString() === this.variantId.toString()
        );

        // Update checkbox state without triggering change event
        this.checkbox.checked = hasGiftWrap;
        
        console.log("[GIFT_WRAP] Cart checked, has gift wrap:", hasGiftWrap);
      } catch (error) {
        console.error("[GIFT_WRAP] Error checking cart:", error);
      }
    }

    async handleCheckboxChange(event) {
      if (this.isProcessing) {
        console.log("[GIFT_WRAP] Already processing, ignoring...");
        event.preventDefault();
        return;
      }

      const isChecked = this.checkbox.checked;
      console.log("[GIFT_WRAP] Checkbox changed to:", isChecked);

      if (isChecked) {
        await this.addGiftWrap();
      } else {
        await this.removeGiftWrap();
      }
    }

    showLoader() {
      if (this.loader) {
        this.loader.style.display = 'flex';
      }
      if (this.checkbox) {
        this.checkbox.disabled = true;
      }
      this.isProcessing = true;
    }

    hideLoader() {
      if (this.loader) {
        this.loader.style.display = 'none';
      }
      if (this.checkbox) {
        this.checkbox.disabled = false;
      }
      this.isProcessing = false;
    }

    async addGiftWrap() {
      this.showLoader();
      console.log("[GIFT_WRAP] Adding gift wrap...");

      try {
        // Add gift wrap to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: this.variantId,
            quantity: 1,
            properties: {
              '_gift_wrap': 'true'
            }
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add gift wrap');
        }

        const result = await response.json();
        console.log("[GIFT_WRAP] Gift wrap added:", result);

        // Update cart UI
        await this.updateCart();

      } catch (error) {
        console.error("[GIFT_WRAP] Error adding gift wrap:", error);
        this.checkbox.checked = false;
        alert('Hediye paketi eklenirken bir hata oluştu. Lütfen tekrar deneyin.');
      } finally {
        this.hideLoader();
      }
    }

    async removeGiftWrap() {
      this.showLoader();
      console.log("[GIFT_WRAP] Removing gift wrap...");

      try {
        // Get current cart to find gift wrap line item key
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        const giftWrapItem = cart.items.find(item => 
          item.variant_id.toString() === this.variantId.toString()
        );

        if (!giftWrapItem) {
          console.log("[GIFT_WRAP] Gift wrap not found in cart");
          this.hideLoader();
          return;
        }

        console.log("[GIFT_WRAP] Found gift wrap item:", giftWrapItem.key);

        // Remove gift wrap from cart
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: giftWrapItem.key,
            quantity: 0
          })
        });

        if (!response.ok) {
          throw new Error('Failed to remove gift wrap');
        }

        const result = await response.json();
        console.log("[GIFT_WRAP] Gift wrap removed:", result);

        // Update cart UI
        await this.updateCart();

      } catch (error) {
        console.error("[GIFT_WRAP] Error removing gift wrap:", error);
        this.checkbox.checked = true;
        alert('Hediye paketi kaldırılırken bir hata oluştu. Lütfen tekrar deneyin.');
      } finally {
        this.hideLoader();
      }
    }

    async updateCart() {
      try {
        console.log("[GIFT_WRAP] Updating cart...");

        // Use theme's cart update mechanism
        const cartItemsElement = document.querySelector('cart-items');
        
        if (cartItemsElement && typeof cartItemsElement.getCart === 'function') {
          // Use theme's built-in method (best option - this handles everything)
          console.log("[GIFT_WRAP] Using theme's getCart method");
          cartItemsElement.getCart();
          
          // Wait for theme to update then re-check checkbox
          setTimeout(() => {
            this.checkGiftWrapInCart();
          }, 600);
        } else {
          // Fallback: Manual update using theme's API endpoint
          console.log("[GIFT_WRAP] Using manual cart update");
          
          const response = await fetch('/cart?section_id=api-cart-items');
          const html = await response.text();
          
          const element = document.createElement('div');
          element.innerHTML = html;
          
          const cleanResponse = element.querySelector('[data-api-content]');
          
          if (cleanResponse) {
            // Update cart line items
            const currentCartItems = document.querySelector('[data-items-holder]');
            const newLineItems = cleanResponse.querySelector('[data-api-line-items]');
            
            if (currentCartItems && newLineItems) {
              currentCartItems.innerHTML = newLineItems.innerHTML;
              console.log("[GIFT_WRAP] Line items updated");
            }
            
            // Update cart prices
            const currentPriceHolder = document.querySelector('[data-cart-price-holder]');
            const newCartPrice = cleanResponse.querySelector('[data-api-cart-price]');
            
            if (currentPriceHolder && newCartPrice) {
              currentPriceHolder.innerHTML = newCartPrice.innerHTML;
              console.log("[GIFT_WRAP] Cart prices updated");
            }
            
            // Get updated cart data
            const cartData = await fetch('/cart.js').then(r => r.json());
            
            // Update cart count
            const cartCountElements = document.querySelectorAll('[data-cart-count]');
            cartCountElements.forEach(el => {
              el.textContent = cartData.item_count;
              el.dataset.cartCount = cartData.item_count;
            });
            
            // Trigger theme's free shipping update if available
            if (cartItemsElement && typeof cartItemsElement.updateProgress === 'function') {
              cartItemsElement.subtotal = cartData.total_price;
              cartItemsElement.updateProgress();
              cartItemsElement.freeShippingMessageHandle(cartData.total_price);
            } else {
              // Manual free shipping update as fallback
              await this.updateFreeShipping(cartData);
            }
            
            console.log("[GIFT_WRAP] Cart updated");
          }
          
          // Re-check gift wrap status after update
          setTimeout(() => {
            this.checkGiftWrapInCart();
          }, 300);
        }

        console.log("[GIFT_WRAP] Cart updated successfully");
      } catch (error) {
        console.error("[GIFT_WRAP] Error updating cart:", error);
        // Fallback: reload the page
        window.location.reload();
      }
    }

    async updateFreeShipping(cart) {
      try {
        const freeShippingElements = document.querySelectorAll('[data-free-shipping]');
        if (!freeShippingElements.length) return;

        freeShippingElements.forEach(freeShippingElement => {
          const limitStr = freeShippingElement.dataset.freeShippingLimit;
          if (!limitStr) return;

          const limit = parseFloat(limitStr) * 100;
          const subtotal = cart.total_price;
          const percent = Math.min(100, (subtotal / limit) * 100);
          
          console.log("[GIFT_WRAP] Free shipping:", { limit, subtotal, percent });

          // Update progress bar
          const progressBar = freeShippingElement.querySelector('[data-progress-bar]');
          if (progressBar) {
            progressBar.value = percent;
          }

          // Update remaining amount text
          const leftToSpend = freeShippingElement.querySelector('[data-left-to-spend]');
          if (leftToSpend) {
            const remaining = Math.max(0, limit - cart.total_price);
            
            // Use theme's money format if available
            if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
              leftToSpend.innerHTML = Shopify.formatMoney(remaining, theme.moneyFormat || '{{amount}}').replace('.00', '');
            } else {
              // Fallback format
              const formatted = (remaining / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
              leftToSpend.textContent = formatted + ' TL';
            }
          }

          // Toggle success state
          if (subtotal >= limit) {
            freeShippingElement.classList.add('is-success');
          } else {
            freeShippingElement.classList.remove('is-success');
          }
        });

        console.log("[GIFT_WRAP] Free shipping bars updated");
      } catch (error) {
        console.error("[GIFT_WRAP] Error updating free shipping:", error);
      }
    }
  }

  // Initialize Gift Wrap when DOM is loaded
  let giftWrapInstance = null;

  const initGiftWrap = () => {
    // Always try to find checkbox (it might be replaced during cart updates)
    const checkbox = document.querySelector('[data-gift-wrap-checkbox]');
    
    if (checkbox && !giftWrapInstance) {
      giftWrapInstance = new GiftWrap();
      console.log("[GIFT_WRAP] New instance created");
    } else if (checkbox && giftWrapInstance) {
      // Update instance reference if checkbox exists but might have been replaced
      giftWrapInstance.checkbox = checkbox;
      giftWrapInstance.container = document.querySelector('[data-gift-wrap-container]');
      giftWrapInstance.loader = document.querySelector('[data-gift-wrap-loader]');
      
      // Re-initialize to rebind event listeners
      giftWrapInstance.init();
      console.log("[GIFT_WRAP] Instance updated and re-initialized");
    }
  };

  document.addEventListener('DOMContentLoaded', initGiftWrap);

  // Also initialize when cart drawer is opened
  document.addEventListener('cart:drawer:open', () => {
    console.log("[GIFT_WRAP] Cart drawer opened");
    setTimeout(() => {
      initGiftWrap();
    }, 100);
  });

  // Re-initialize after theme cart updates
  document.addEventListener('theme:product:added', () => {
    console.log("[GIFT_WRAP] Product added to cart");
    setTimeout(() => {
      initGiftWrap();
    }, 300);
  });

  // Listen for cart updates (custom event)
  document.addEventListener('cart:updated', () => {
    console.log("[GIFT_WRAP] Cart updated event received");
    setTimeout(() => {
      initGiftWrap();
    }, 100);
  });

  // Initialize if DOM already loaded
  if (document.readyState !== 'loading') {
    initGiftWrap();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
